import React, { useState, useEffect } from 'react'
import Wrapper from '../Wrapper'
import Chats from '../../pages/new_operator/Chats'
import { Paper, Accordion, AccordionSummary, Box, Typography, Tabs, Tab, TextField } from '@mui/material'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import TelegramIcon from '@mui/icons-material/Telegram'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { menu, graphics, telecomunication } from '../../translate'
import qs from 'query-string'
import Api from '../../Api'
import { greenTheme, historyChatsStyles, operatorReportStyles as opStyles } from '../../helpers/style'
import '../../assets/style/style.css'
import { useSelector } from 'react-redux'
import { hasHistoryView, hasEmployeeTelegram, hasEmployeeWhatsApp } from '../../helpers/employeePermissions'

function HistoryChats() {
  const location = useLocation()
  const navigate = useNavigate()
  const { accountId } = useParams()
  const query = qs.parse(location.search, { arrayFormat: 'comma' })
  const langIndex = +localStorage.getItem('atsLang') || 1
  const employeeData = useSelector((state) => state.users.employeeData)
  const fetchedEmployee = useSelector((state) => state.users.fetchedEmployee)
  const [expanded, setExpanded] = useState(true)
  const [telegram, setTelegram] = useState(null)
  const [telegramAccounts, setTelegramAccounts] = useState([])
  const [selectedAccountId, setSelectedAccountId] = useState(accountId || null)
  const [loading, setLoading] = useState(true)
  const [answerer, setAnswerer] = useState('')

  useEffect(() => {
    fetchTelegramAccounts()
  }, [])

  useEffect(() => {
    if (accountId) {
      setSelectedAccountId(accountId)
    } else if (telegramAccounts.length > 0 && !selectedAccountId) {
      setSelectedAccountId(telegramAccounts[0].id)
    }
  }, [accountId, telegramAccounts])

  useEffect(() => {
    if (selectedAccountId && selectedAccountId !== accountId) {
      navigate(`/history_telegram/${selectedAccountId}${location.search ? '?' + qs.stringify(query, { arrayFormat: "comma" }) : ''}`)
    }
  }, [selectedAccountId])

  const normalizedId = (obj) => (obj?.id != null ? String(obj.id) : obj?.ID != null ? String(obj.ID) : '')

  const isBuddyAlive = !!fetchedEmployee

  useEffect(() => {
    if (isBuddyAlive && employeeData?.notes != null && String(employeeData.notes).trim() !== '') {
      setAnswerer((prev) => (prev === '' ? String(employeeData.notes).trim() : prev))
    }
  }, [isBuddyAlive, employeeData?.notes])

  const hasEmployeeTelegrams = Array.isArray(employeeData?.telegrams) && employeeData.telegrams.length > 0
  const displayedAccounts = hasEmployeeTelegrams
    ? employeeData.telegrams.map((t) => {
        const full = telegramAccounts.find((acc) => normalizedId(acc) === normalizedId(t))
        return full != null ? full : t
      })
    : telegramAccounts

  useEffect(() => {
    const allowed = hasEmployeeTelegrams
      ? employeeData.telegrams.map((t) => {
          const full = telegramAccounts.find((acc) => normalizedId(acc) === normalizedId(t))
          return full != null ? full : t
        })
      : telegramAccounts
    if (allowed.length > 0 && selectedAccountId && !allowed.some((a) => normalizedId(a) === normalizedId({ id: selectedAccountId }))) {
      setSelectedAccountId(allowed[0].id)
      setTelegram(allowed[0].id)
    }
  }, [telegramAccounts, employeeData?.telegrams, selectedAccountId])

  const fetchTelegramAccounts = async () => {
    try {
      setLoading(true)
      const res = await Api.telegramGet()
      const accounts = res.data?.data || []
      setTelegramAccounts(accounts)
      
      if (accounts.length > 0) {
        if (accountId) {
          setTelegram(accountId)
          setSelectedAccountId(accountId)
        } else {
          setTelegram(accounts[0].id)
          setSelectedAccountId(accounts[0].id)
        }
      } else {
        setTelegram(accountId)
        setSelectedAccountId(accountId)
      }
    } catch (e) {
      console.error('Failed to fetch Telegram accounts:', e)
      setTelegramAccounts([])
      setTelegram(accountId)
      setSelectedAccountId(accountId)
    } finally {
      setLoading(false)
    }
  }

  const handleAccountChange = (accountId) => {
    setSelectedAccountId(accountId)
    setTelegram(accountId)
  }

  const pathname = location.pathname || ''
  const isHistoryActive = pathname === '/history'
  const isOperatorReportActive = pathname === '/operator_report' || pathname.startsWith('/operator_report/')
  const isTelegramActive = pathname.startsWith('/history_telegram')
  const isWhatsappActive = pathname.startsWith('/history_whatsapp')
  const showCallHistoryNav = hasHistoryView(employeeData)
  const showTelegramNav = hasEmployeeTelegram(employeeData)
  const showWhatsappNav = hasEmployeeWhatsApp(employeeData)
  const primaryColor = greenTheme?.primary || '#7ebc0a'
  const whatsappGreen = '#25D366'

  return (
    <Wrapper>
      <div className="tableParent">
        <Paper sx={{ minWidth: 'fit-content', fontSize: 10, boxShadow: 'none', borderRadius: 0 }}>
          <Accordion
            expanded={expanded}
            sx={{
              borderRadius: '0 !important',
              '&:before': { borderRadius: 0 },
              '&:first-of-type': { borderTopLeftRadius: 0, borderTopRightRadius: 0 },
              '&:last-of-type': { borderBottomLeftRadius: 0, borderBottomRightRadius: 0 },
              '& .MuiAccordionSummary-root': { borderRadius: 0 },
              '& .MuiAccordionDetails-root': { borderRadius: 0 },
            }}
          >
            <AccordionSummary
              sx={{ ...historyChatsStyles.accordionSummary, borderRadius: 0 }}
              aria-expanded="true"
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <div className="w-100" style={historyChatsStyles.headerContainer}>
                <div style={historyChatsStyles.headerRow}>
                  {showCallHistoryNav ? (
                  <>
                  <h1 style={historyChatsStyles.headerTitle}>
                    <Link
                      to={`/history?${qs.stringify(query, { arrayFormat: "comma" })}`}
                      style={{ color: isHistoryActive ? primaryColor : undefined, textDecoration: 'none' }}
                    >
                      {menu.history[+localStorage.getItem('atsLang') || 1]}
                    </Link>
                  </h1>
                  <div className="header_border" style={{ height: 40, marginBottom: 15 }} />
                  <h1 style={historyChatsStyles.headerTitle}>
                    <Link
                      to={`/operator_report`}
                      onClick={() => navigate('/operator_report')}
                      style={{ color: isOperatorReportActive ? primaryColor : undefined, textDecoration: 'none' }}
                    >
                      {graphics.graphic[+localStorage.getItem('atsLang') || 1]}
                    </Link>
                  </h1>
                  <div className="header_border" style={{ height: 40, marginBottom: 15 }} />
                  </>
                  ) : null}
                  {showTelegramNav ? (
                  <>
                  <div style={{ ...historyChatsStyles.headerRow, gap: 8 }}>
                    <h1 style={historyChatsStyles.headerTitle}>
                      <Link
                        to={`/history_telegram/${telegram ?? selectedAccountId ?? employeeData?.telegrams?.[0]?.id ?? ''}`}
                        style={{ color: isTelegramActive ? '#0088cc' : undefined, textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 8 }}
                      >
                        <TelegramIcon sx={{ fontSize: 22, color: isTelegramActive ? '#0088cc' : 'inherit' }} />
                        Telegram
                      </Link>
                    </h1>
                  </div>
                  {showWhatsappNav ? <div className="header_border" style={{ height: 40, marginBottom: 15 }} /> : null}
                  </>
                  ) : null}
                  {showWhatsappNav ? (
                  <div style={{ ...historyChatsStyles.headerRow, gap: 8 }}>
                    <h1 style={historyChatsStyles.headerTitle}>
                      <Link
                        to="/history_whatsapp"
                        style={{ color: isWhatsappActive ? whatsappGreen : undefined, textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 8 }}
                      >
                        <WhatsAppIcon sx={{ fontSize: 22, color: isWhatsappActive ? whatsappGreen : 'inherit' }} />
                        {telecomunication.whatsapp_title?.[langIndex] || 'WhatsApp'}
                      </Link>
                    </h1>
                  </div>
                  ) : null}
                </div>

                <span style={{ display: 'flex', alignItems: 'center' }}>
                  
                </span>
              </div>
            </AccordionSummary>
          </Accordion>
        </Paper>

        {displayedAccounts.length >= 1 && (
          <Paper sx={{ ...historyChatsStyles.selectorPaper, pt: 0 }}>
            <Tabs
              value={String(selectedAccountId ?? displayedAccounts[0]?.id ?? '')}
              onChange={(_, v) => {
                const acc = displayedAccounts.find((a) => String(a.id) === String(v))
                if (acc) handleAccountChange(acc.id)
              }}
              variant="fullWidth"
              sx={{
                ...opStyles.tabs,
                marginBottom: 0,
                '& .Mui-selected': { color: '#0088cc !important' },
                '& .Mui-selected .MuiSvgIcon-root': { color: '#0088cc !important' },
                '& .MuiTabs-indicator': { backgroundColor: '#0088cc', height: 3 },
              }}
            >
              {displayedAccounts.map((account) => {
                const accountTitle = account.phone
                  ? `${telecomunication.telegram_handle_messaging?.[langIndex] || 'Telegram'} - ${account.phone}`
                  : `${telecomunication.telegram_handle_messaging?.[langIndex] || 'Telegram'} #${account.id}`
                return (
                  <Tab
                    key={account.id}
                    value={String(account.id)}
                    icon={<TelegramIcon sx={{ fontSize: 20 }} />}
                    iconPosition="start"
                    label={accountTitle}
                  />
                )
              })}
            </Tabs>
          </Paper>
        )}
      </div>
      <Chats answerer={isBuddyAlive ? answerer : undefined} />
    </Wrapper>
  )
}

export default HistoryChats